import React from 'react';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import { useSelector } from 'react-redux';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

function InvalidCouponInfoMessage() {
    const inValidCouponText =
        useSelector((state) => state.context?.messagesTexts?.couponText?.inValidCouponText) || '';
    const coAppliedAdjustments = useSelector((state) => state.coAppliedAdjustments) || {};
    const newCookie = Cookies.load('showCouponMessage', true);
    return !coAppliedAdjustments.resetCouponMessage && newCookie ? (
        <div
            className={dt([
                'w-[356px]',
                'xl:mt-4',
                'md:px-0',
                'px-0',
                'text-left',
                'mx-auto',
                'my-0',
                'mb-4',
            ])}
        >
            <MessageBox
                type="information"
                level="section"
                hasClose={false}
                automationId="at-fpac-invalid-coupon-message"
            >
                {inValidCouponText}
            </MessageBox>
        </div>
    ) : null;
}

export default InvalidCouponInfoMessage;
